// extracted by mini-css-extract-plugin
export var animationContainer = "_i7-0";
export var asteriskIcon = "_i7-8";
export var conversationLeftSection = "_i7-4";
export var conversationListItem = "_i7-3";
export var conversationMiddleSection = "_i7-5";
export var conversationRightSection = "_i7-6";
export var detailsContent = "_i7-1";
export var listContainer = "_i7-7";
export var modalContent = "_i7-2";